// ABOUTME: Hands an SSO register-page user off to their IdP once the account update has finished
// ABOUTME: Observes the SSO login store and mounts SingleSignOn when it reaches the created state
import { emptyFragment } from '@execonline-inc/execonline-ui';
import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import * as React from 'react';
import SsoLoginStore from '.';
import { SsoAuth } from '../../DiscoveryPortal/RegisterResourceStore/Types';
import SingleSignOn from './SingleSignOn';

interface Props {
  store: SsoLoginStore;
  auth: SsoAuth;
}

const SsoHandoff: React.FC<Props> = ({ store, auth }) => {
  switch (store.state.kind) {
    case 'created': {
      return <SingleSignOn store={store} state={store.state} auth={auth} />;
    }
    case 'waiting':
    case 'ready':
    case 'ready-with-client-errors':
    case 'ready-with-server-errors':
    case 'creating':
    case 'error':
    case 'server-error': {
      return emptyFragment();
    }
    default: {
      return assertNever(store.state);
    }
  }
};

export default observer(SsoHandoff);
